import { RecipesListPageProps, WithGlobalData } from '@domains/view';

import { BFFCookieClientClass } from '@api/client/bff';
import { RecipesListPayload, RecipesListResult } from '@api/protocol';

import { DEFAULT_PAGE_SIZE_RECIPES } from '@utils/constants';
import { isPageOutOfRange } from '@utils/pagination';
import { parsePositiveInt } from '@utils/query';

import { RecipesView } from '@views/RecipesView/RecipesView';

type QueryParams = {
    page?: QueryParam;
    rubric_slug?: string;
};

export const getServerSideProps: BFF.GetPageServerSideProps<
    WithGlobalData<RecipesListPageProps>,
    QueryParams
> = async (context) => {
    const { req, query } = context;

    const page = parsePositiveInt(query.page) ?? 1;
    const rubric_slug = query.rubric_slug;

    const result = await BFFCookieClientClass<RecipesListPageProps>({
        request: req,
        isNotFoundOnErrorShown: true, // rubric_slug may be invalid
    })
        .addToStack<RecipesListPayload, RecipesListResult>({
            prop: 'data',
            url: '/api/recipes/list',
            payload: { rubric_slug, page, per_page: DEFAULT_PAGE_SIZE_RECIPES },
        })
        .getServerProps();

    if ('props' in result && 'data' in result.props) {
        const { total, page_size } = result.props.data;
        if (isPageOutOfRange(page, total, page_size)) {
            return { notFound: true };
        }
    }

    return result;
};

export default RecipesView;
